import { useCallback, useState } from "react";
import { useAuth } from "./AuthContext";

interface CreditBalance {
  totalBalance: number;
  planBalance: number;
  topupBalance: number;
}

export function useCredit() {
  const { user } = useAuth();
  const [credit, setCredit] = useState<CreditBalance | null>(null);

  const fetchCredit = useCallback(async () => {
    const response = await fetch("/api/credit", {
      credentials: "include",
    });
    if (response.ok) {
      const data: CreditBalance = await response.json();
      setCredit(data);
      return data;
    }
    console.error("Failed to fetch credit balance, response:", await response.text());
    return null;
  }, []);

  return { user, credit, fetchCredit };
}
